var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHeatmapIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Heatmap Icon"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11801_31905)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 4,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 30",
    width: 10,
    height: 10,
    fill: "#FEE800"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 31",
    y: 10,
    width: 10,
    height: 10,
    fill: "#FFFF01"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 32",
    y: 20,
    width: 10,
    height: 10,
    fill: "#FEE800"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 33",
    y: 30,
    width: 10,
    height: 10,
    fill: "#FFB901"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 34",
    x: 10,
    width: 10,
    height: 10,
    fill: "#FAC004"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 35",
    x: 10,
    y: 10,
    width: 10,
    height: 10,
    fill: "#AE080A"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 36",
    x: 10,
    y: 20,
    width: 10,
    height: 10,
    fill: "#FA4113"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 37",
    x: 10,
    y: 30,
    width: 10,
    height: 10,
    fill: "#F58A0A"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 38",
    x: 20,
    width: 10,
    height: 10,
    fill: "#F58A0A"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 39",
    x: 20,
    y: 10,
    width: 10,
    height: 10,
    fill: "#C40809"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 40",
    x: 20,
    y: 20,
    width: 10,
    height: 10,
    fill: "#630305"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 41",
    x: 20,
    y: 30,
    width: 10,
    height: 10,
    fill: "#F58A0A"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 42",
    x: 30,
    width: 10,
    height: 10,
    fill: "#FFFF81"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 43",
    x: 30,
    y: 10,
    width: 10,
    height: 10,
    fill: "#ACFF7B"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 44",
    x: 30,
    y: 20,
    width: 10,
    height: 10,
    fill: "#6DE221"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 45",
    x: 30,
    y: 30,
    width: 10,
    height: 10,
    fill: "#6BCE33"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11801_31905"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 4,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeatmapIcon);
export default __webpack_public_path__ + "static/media/heatmap_icon.5fe1eca2f63bb8f04063358b5e7071dc.svg";
export { ForwardRef as ReactComponent };